/* global globalThis */

/**
 * Local bundles extracted from the former monolithic index.js entry point.
 *
 * Scripts that the backend already selects with Model.ShouldAdd... remain in
 * the backend PageBody partial and must not be registered here.
 */
export const featureRegistry = [
  // Always needed: creates the shared HMS.Common instance.
  {
    name: 'core',
    bundle: 'index.js',
    selector: 'body',
    initialize: () => { globalThis.HMS.Common = new globalThis.HMSCommon(); }
  },
  // Generic UI used across multiple component types.
  {
    name: 'common',
    bundle: 'feature-common.js',
    selector: '.js-accordion, .js-tabs, .js-select, .js-select-multilevel, .js-show-more-container, .js-toggle-tooltip, .js-popup-container, .js-table, .iframe-popup, .js-size-guide-popup, .js-clicked-scroll-to-element, .js-external-links'
  },
  // All Swiper-based carousel variants share one conditional bundle.
  {
    name: 'carousels',
    bundle: 'feature-carousels.js',
    selector: '.js-intro-carousel, .js-product-carousel, .js-boxCarousel, .js-carousel, .js-carousel-alt, .js-carousel-gallery, .js-protects-carousel, .js-product-supporting-carousel-frost, .js-product-supporting-carousel-jobst, .js-product-list'
  },
  // Product presentation UI; backend-owned product integrations stay separate.
  {
    name: 'product-ui',
    bundle: 'feature-product.js',
    selector: '.js-view-options, .js-info-panel, .js-product-title, .js-product-compare-popup, .js-product-card, .js-product-selector, .js-review'
  },
  // Deferred until the component is near the viewport.
  {
    name: 'dealer-locator',
    bundle: 'dealer-locator.js',
    selector: '.dealer-locator',
    priority: 'viewport'
  }
];
